import { IMAGES } from "@/lib/site";
import { SectionHeading, Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    idx: "01",
    title: "Parcel Delivery Operations",
    img: IMAGES.vanLoad,
    alt: "Courier loading parcels into a delivery van",
    desc: "Daily manifests, retail replenishment and overflow parcel capacity delivered under your brand and SLA — with POD captured on every consignment.",
    span: "md:col-span-7",
  },
  {
    idx: "02",
    title: "Dedicated Bakkie Transport",
    img: IMAGES.bakkie,
    alt: "Loaded bakkie transporting cargo on a national route",
    desc: "1-ton dropside and canopy bakkies for scheduled routes, linehaul shuttles and tight urban access where big trucks can't reach.",
    span: "md:col-span-5",
  },
  {
    idx: "03",
    title: "Last-Mile Subcontracting",
    img: IMAGES.sorting,
    alt: "Sorted parcels ready for dispatch in a distribution hub",
    desc: "Dependable outsourced wheels for national courier networks — branch overflow, peak-season surges and same-day relief capacity.",
    span: "md:col-span-5",
  },
  {
    idx: "04",
    title: "Scheduled Distribution Runs",
    img: IMAGES.warehouse,
    alt: "Palletised goods in a national distribution warehouse",
    desc: "Fixed daily and weekly route contracts connecting warehouses, distribution hubs and retail doors on reliable transit times.",
    span: "md:col-span-7",
  },
];

export const Services = () => (
  <section id="services" className="scroll-mt-24 py-20 md:py-28" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionHeading
        eyebrow="Services & Capabilities"
        title="Fleet, hands & routes — ready to deploy under contract."
        intro="Whether you need one dedicated bakkie on a daily route or relief capacity across a regional network, NGCONDE plugs into your operation as the accountable delivery contractor."
      />

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-12 md:gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.idx} delay={i * 0.07} className={s.span}>
            <article
              data-testid={`service-card-${s.idx}`}
              className="group relative h-[340px] overflow-hidden rounded-2xl border border-white/10 transition-colors duration-300 hover:border-[#FF6B00]/60 md:h-[420px]"
            >
              <img
                src={s.img}
                alt={s.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-[#080C14] via-[#080C14]/55 to-[#080C14]/10"
                aria-hidden="true"
              />
              <div className="relative flex h-full flex-col justify-end p-6 md:p-8">
                <p className="font-mono text-xs font-semibold tracking-[0.3em] text-[#FF6B00]">
                  {s.idx}
                </p>
                <h3 className="mt-3 font-display text-2xl font-black uppercase tracking-tight text-white md:text-3xl">
                  {s.title}
                </h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-300">
                  {s.desc}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
